// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-7f66521d] {\n  background: #ffffff;\n  box-shadow: 0px 4px 35px rgba(0, 0, 0, 0.1);\n  border-radius: 1rem;\n  padding: 1.2rem;\n}\n.providers[data-v-7f66521d] {\n  display: flex;\n  justify-content: flex-end;\n}\n.providers svg[data-v-7f66521d] {\n  display: block;\n}\n.row[data-v-7f66521d] {\n  margin-top: 0.7rem;\n}\n.row-inline[data-v-7f66521d] {\n  display: flex;\n  -moz-column-gap: 10px;\n       column-gap: 10px;\n}", ""]);
// Exports
module.exports = exports;
